<rr-start-logo class="logo" color="inverse" routerLink="/"></rr-start-logo>
<div class="card col">
    <img src="/images/congrat-signup.png" alt="" />
    <h1 i18n>You're almost there!</h1>
    <div>
        Your coach needs to review your request.<br />
        You will get a separate e-mail once a decision has been made.<br />
        <h4>E-Mail not found? Please also check your Spam folder.</h4>
    </div>
</div>
